import React from "react";
import "../Text/Text.css";

const Text = () => {
  return (
    <div className="text-center p-8">
      <h2 className="text-2xl font-bold mb-4 he">Experience Luxury Without the Price Tag</h2>
    <p className="het text-center">
    Why pay more for luxury travel? Journey Experts unlocks exclusive deals on <a href="/business-flight">business class flights.</a> 
</p>
{/*-
giving you first-class comfort at economy prices. Fly smarter, travel farther, and experience the world like never before! 
<p className="het">

  Dreaming of first-class flights to <a href="/destination/australia">Australia</a>, <a href="/destination/canada">Canada</a>, <a href="/destination/usa">USA</a>, or <a href="/destination/south%20africa">South Africa</a>? Upgrading your journey is easier and more affordable than you think!
</p>
-*/}

    </div>
  );
};

export default Text;
